import React, { useState } from "react";
import "../../assets/styles/auth/forgotPassword.scss";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import NewInput from "../../components/simple/NewInput";
import ArrowBackAuth from "../../assets/svg/arrow-back-auth.svg";
import { useDispatch, useSelector } from "react-redux";
import { apiForgetPassword, apiSetAlert } from "../../api/appApi";
import iconLoading from "../../assets/svg/icon-loading.svg";
import backgroundNewAuth from "../../assets/svg/background-new-auth.svg";
import { RecaptchContainer } from "./components";

import { styled } from "@mui/material";
import Captcha from "./Captcha";

const ForgetText = styled("div")(({ theme }) => ({
  width: "100%",
  fontWeight: 400,
  fontSize: "0.8rem",
  color: theme.palette.text.secondary,
}));

export default function ForgetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);

  const [reCaptcha, setReCaptcha] = useState(false);
  const [inputFields, setInputFields] = useState({
    ePhone: "",
  });

  function goToRegister() {
    navigate("/auth/register");
  }

  function goToLogin(e) {
    navigate("/auth/login");
    e.preventDefault();
  }

  function forgetPassword() {
    if (!reCaptcha) {
      dispatch(apiSetAlert("لطفا راستی آزمایی را تکمیل نمایید", "warning"));
    } else {
      dispatch(apiForgetPassword(inputFields, navigate));
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <div className="wrap-background">
        <img src={backgroundNewAuth} alt="backgroundNewAuth" className="background-new-auth" />
        <div className="wrap-forgetPassword">
          {/* <img src={backgroundAuth} alt="backgroundAuth" /> */}
          <form>
            <h5>کلمه عبور را فراموش کرده اید؟</h5>
            <ForgetText style={{ marginTop: 20 }}>
              آدرس ایمیل یا تلفن همراه که با آن ثبت نام کرده اید را وارد کنید و سپس روی دکمه ارسال کد بازنشانی
              کلیک نمایید.
            </ForgetText>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 mb-3">
                <NewInput
                  placeholder={"شماره موبایل خود را وارد نمایید"}
                  label={"تلفن همراه"}
                  onChange={(e) =>
                    setInputFields(() => {
                      return {
                        ePhone: e.target.value,
                      };
                    })
                  }
                />
              </div>
              <div className="py-4">
                <Captcha validate={(res) => setReCaptcha(res)} submit={forgetPassword} />
              </div>
              {/* <RecaptchContainer
              // className="col-lg-12 col-md-12 col-sm-12 col-xs-12 recaptch-register p-5 pt-0 pb-0 mt-5"
              >
                <ReCAPTCHA
                  sitekey="6Ld6C7IcAAAAAKO3b-DCLe56b0yEQ7LM1Rjuh_-B"
                  hl={"fa"}
                  onChange={() => setReCaptcha(true)}
                />
              </RecaptchContainer> */}
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btns">
              <button
                type="button"
                className="btn-enter"
                onClick={() => forgetPassword()}
                disabled={sendingRequest}
              >
                {sendingRequest ? <img src={iconLoading} alt="loading" /> : "ارسال رمز عبور جدید"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 footer text-center">
          <a onClick={goToLogin} href="/auth/login">
            <img src={ArrowBackAuth} alt="ArrowBackAuth" />
            <b>بازگشت به صفحه ورود</b>
          </a>
        </div>
      </div>
    </div>
  );
}
